import React from "react";
import { useRecruiter } from "../context/RecruiterContext.tsx"
import CanidateDashboard from "../components/CandidateDashboard.tsx"
import RecruiterDashboard from "../components/recruiterDashboard.tsx"

export function Dashboard() {

    const isRecruiter = useRecruiter()
    // there are multiple dashboards all based on if you are a recruiter or not. 

    return (
        <>{isRecruiter.isRecruiter === true ? <RecruiterDashboard isRecruiter={isRecruiter} /> : <CanidateDashboard isRecruiter={isRecruiter} />}</>
    )
};